import React, { useState } from 'react';
import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import "../Style/Payment.css";
import "../Style/Responsive.css";

const PaymentPage = () => {
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [error, setError] = useState("");
  const [processing, setProcessing] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    
    // Basic field validation
    if (!cardName || !cardNumber || !expiry || !cvv) {
      setError("All fields are required.");
      return;
    }

    // Validate card number length
    if (cardNumber.length < 16) {
      setError("Card number must be 16 digits.");
      return;
    }
    
    // Validate expiry format: Accepts MM/YY or MM/YYYY
    if (!/^\d{2}\/(\d{2}|\d{4})$/.test(expiry)) {
      setError("Expiry date must be in MM/YY or MM/YYYY format.");
      return;
    }
    
    // Validate that the expiry date is not in the past
    const [expMonthStr, expYearStr] = expiry.split("/");
    const expMonth = parseInt(expMonthStr, 10);
    let fullExpYear;
    if(expYearStr.length === 2) {
      // Assume two-digit years are in the 2000s
      fullExpYear = 2000 + parseInt(expYearStr, 10);
    } else {
      fullExpYear = parseInt(expYearStr, 10);
    }
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() is zero-indexed
    const currentYear = currentDate.getFullYear();

    if (fullExpYear < currentYear || (fullExpYear === currentYear && expMonth < currentMonth)) {
      setError("Card expiry date is outdated. Please enter a valid month/year.");
      return;
    }
    
    // Validate CVV length
    if (cvv.length < 3 || cvv.length > 4) {
      setError("CVV must be 3 or 4 digits.");
      return;
    }
    
    setError("");
    setProcessing(true);

    // Simulate payment processing delay (replace this with your actual payment integration)
    setTimeout(() => {
      setProcessing(false);
      setPaymentSuccess(true);
      // After showing the success message, wait 3 seconds and then redirect
      setTimeout(() => {
        window.location.href = '/programs-loggedIn';
      }, 3000);
    }, 3000);
  };

  return (
    <div className="payment-container">
      <h1>Payment</h1>
      <p>Please enter your card details to complete your subscription.</p>
      
      {paymentSuccess ? (
        <div className="success-message">
          Payment successful! Redirecting...
        </div>
      ) : (
        <form onSubmit={handlePaymentSubmit} className="payment-form">
          <div className="form-group">
            <label className="field-label required">Cardholder Name</label>
            <input
              type="text"
              value={cardName}
              onChange={(e) => setCardName(e.target.value)}
              className="input-field"
              placeholder="John Doe"
              required
            />
          </div>
          <div className="form-group">
            <label className="field-label required">Card Number</label>
            <input
              type="text"
              value={cardNumber}
              onChange={(e) => setCardNumber(e.target.value)}
              className="input-field"
              placeholder="1234567812345678"
              maxLength="16"
              required
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="field-label required">Expiry Date</label>
              <input
                type="text"
                value={expiry}
                onChange={(e) => setExpiry(e.target.value)}
                className="input-field"
                placeholder="MM/YY or MM/YYYY"
                required
              />
            </div>
            <div className="form-group">
              <label className="field-label required">CVV</label>
              <input
                type="text"
                value={cvv}
                onChange={(e) => setCvv(e.target.value)}
                className="input-field"
                placeholder="123"
                maxLength="4"
                required
              />
            </div>
          </div>
          <button type="submit" disabled={processing} className="payment-button">
            {processing ? "Processing..." : "Pay Now"}
          </button>
          {error && <div className="error-message">{error}</div>}
        </form>
      )}
    </div>
  );
};

export default PaymentPage;
